module.exports = __webpack_public_path__ + "static/media/ios-easel.d56d335b.svg";